import { BodyLG, BodySM } from "../../../typography";
import {
  faArrowRight,
  faChevronDown,
  faChevronUp,
  faUpRightFromSquare,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavItem } from "../config/navConfig";
import { NavLink } from "./NavLink";
import { cn } from "@verse_core/shared_components/ClassName";
import { useDropdown } from "../hooks/useDropdown";
import { useLocation } from "react-router-dom";

interface DesktopNavItemProps extends NavItem {
  isDark: boolean;
}

export const DesktopNavItem = ({
  href,
  title,
  dropdownItems,
  isDark,
}: DesktopNavItemProps) => {
  const isDropdown = !!dropdownItems;
  const { isOpen, ref, handleMouseEnter, handleMouseLeave, toggleDropdown } =
    useDropdown();
  const location = useLocation();
  const isActive = location.pathname === href;

  const navItemContent = (
    <div
      ref={ref}
      onClick={toggleDropdown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className={cn(
        "tw-relative tw-flex tw-h-[4.5em] tw-cursor-pointer tw-items-center tw-gap-[1em] tw-border-x-0 tw-border-b-[2px] tw-border-t-0 tw-border-solid tw-border-transparent",
        !isDropdown
          ? isDark
            ? "hover:tw-border-white"
            : "hover:tw-border-blue-1"
          : "",
        isActive && !isDropdown
          ? isDark
            ? "tw-border-white"
            : "tw-border-blue-1"
          : "",
      )}
    >
      <div className="tw-flex tw-items-center tw-gap-x-[.5em]">
        <BodyLG
          className={cn("tw-my-0", isDark ? "tw-text-white" : "tw-text-gray-2")}
        >
          {title}
        </BodyLG>
        {isDropdown && (
          <FontAwesomeIcon
            icon={isOpen ? faChevronUp : faChevronDown}
            className={cn(
              "tw-h-[1em] tw-w-[1em]",
              isDark ? "tw-text-white" : "tw-text-gray-2",
            )}
          />
        )}
        {href?.includes("https://") && !href.includes("versemedical.com") && (
          <FontAwesomeIcon
            icon={faUpRightFromSquare}
            className={cn(
              "tw-h-[1em] tw-w-[1em]",
              isDark ? "tw-text-white" : "tw-text-gray-2",
            )}
          />
        )}
      </div>
      {isOpen && dropdownItems && (
        <div
          className="tw-absolute tw-left-0 tw-top-full tw-z-20 tw-mt-[4px] tw-flex tw-w-[296px] tw-flex-col tw-rounded-[4px] tw-bg-white tw-py-[8px] tw-shadow-md"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {dropdownItems.map((item) => (
            <NavLink
              key={item.title}
              href={item.href}
              className="tw-flex tw-items-start tw-gap-x-[8px] tw-px-[16px] tw-py-[12px] hover:tw-bg-gray-light-4"
            >
              <FontAwesomeIcon
                icon={faArrowRight}
                className="tw-mt-[3px] tw-h-[14px] tw-w-[13px] tw-text-blue-1"
              />
              <div>
                <BodyLG className="tw-mb-0 tw-text-black">{item.title}</BodyLG>
                <BodySM className="tw-mb-0 tw-text-gray-3">
                  {item.description}
                </BodySM>
              </div>
            </NavLink>
          ))}
        </div>
      )}
    </div>
  );

  return href ? (
    <NavLink href={href}>{navItemContent}</NavLink>
  ) : (
    navItemContent
  );
};
